module.exports = {"513221100":"威州镇","513221102":"映秀镇","513221103":"卧龙镇","513221105":"水磨镇","513221106":"漩口镇","513221107":"三江镇","513221108":"耿达镇","513221109":"绵虒镇","513221200":"龙溪乡","513221201":"克枯乡","513221202":"雁门乡","513221204":"银杏乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513221.json
// module id = 2399
// module chunks = 0